import { Box, BoxProps, ColorOptions } from '@jfs/ui-new'
import React from 'react'

export const ToolTipBorder = ({ children, left }: any) => {
  return (
    <Box {...styles.box}>
      <Box {...styles.triangle} left={left} />
      <Box {...styles.triangle2} left={left + 1} />
      {children}
    </Box>
  )
}

const styles = {
  box: {
    position: 'relative',
    borderColor: '#0070B652' as ColorOptions,
    borderTopWidth: 1,
  } as BoxProps,
  triangle: {
    width: 10,
    height: 10,
    position: 'absolute',
    top: -10,
    borderLeftWidth: 10,
    borderLeftColor: 'TRANSPARENT',
    borderRightWidth: 10,
    borderRightColor: 'TRANSPARENT',
    borderBottomWidth: 10,
    borderBottomColor: '#0070B652' as ColorOptions,
  } as BoxProps,
  triangle2: {
    width: 10,
    height: 10,
    position: 'absolute',
    top: -10,
    borderLeftWidth: 9,
    borderLeftColor: 'TRANSPARENT',
    borderRightWidth: 9,
    borderRightColor: 'TRANSPARENT',
    borderBottomWidth: 9,
    borderBottomColor: '#F5F9FC' as ColorOptions,
  } as BoxProps,
}
